import React from "react";
import { useIsAuthenticated } from "react-auth-kit";
import { Navigate, Outlet } from "react-router-dom";

export const LoginLayout = () => {
  const isAuthenticated = useIsAuthenticated();
  return isAuthenticated() ? <Navigate to={"/dashboard"} /> : <Outlet />;
};
